module.exports = __webpack_public_path__ + "img/building-solid.42fd8644.svg";